import { Naics, Franchise, Risk, BalanceSheet, Zip } from ".";
import { CalculationType } from "./Enums";

export class QuickReport {
    NAICS: Naics;
    NAICS_NAME: string;

    CALC_TYPE: CalculationType;

    REVENUE_VALUE: number;
    SDE_VALUE: number;

    ADDITIONAL_QUESTIONS: boolean;

    ENABLE_LOCATION: boolean;
    ZIP: Zip;

    ENABLE_FRANCHISE: boolean;
    IS_FRANCHISE: boolean;
    FRANCHISE_QUESTION: boolean;
    FRANCHISE_NAME: string;
    FRANCHISE: Franchise;
    
    ENABLE_DV: boolean;
    ENABLE_PG: boolean;
    ENABLE_BE: boolean;
    ENABLE_RR: boolean;
    RISK: Risk;

    ENABLE_BALANCE_SHEET: boolean;
    BALANCE_SHEET: BalanceSheet;

    static parse(json: any): QuickReport {
        if (json) {
            const qr = new QuickReport();

            if (json.NAICS)
                qr.NAICS = Naics.parse(json.NAICS);
            qr.NAICS_NAME = json.NAICS_NAME;
            qr.CALC_TYPE = CalculationType[<string>json.CALC_TYPE];
            qr.REVENUE_VALUE = json.REVENUE_VALUE;
            qr.SDE_VALUE = json.SDE_VALUE;
            qr.ADDITIONAL_QUESTIONS = json.ADDITIONAL_QUESTIONS;

            qr.ENABLE_LOCATION = json.ENABLE_LOCATION;
            if (json.ZIP)
                qr.ZIP = Zip.parse(json.ZIP);

            qr.ENABLE_FRANCHISE = json.ENABLE_FRANCHISE;
            qr.IS_FRANCHISE = json.IS_FRANCHISE;
            qr.FRANCHISE_QUESTION = json.FRANCHISE_QUESTION;
            qr.FRANCHISE_NAME = json.FRANCHISE_NAME;
            if (json.FRANCHISE)
                qr.FRANCHISE = Franchise.parse(json.FRANCHISE);

            qr.ENABLE_DV = json.ENABLE_DV;
            qr.ENABLE_PG = json.ENABLE_PG;
            qr.ENABLE_BE = json.ENABLE_BE;
            qr.ENABLE_RR = json.ENABLE_RR;
            if (json.RISK)
                qr.RISK = Risk.parse(json.RISK);

            qr.ENABLE_BALANCE_SHEET = json.ENABLE_BALANCE_SHEET;
            if (json.BALANCE_SHEET)
                qr.BALANCE_SHEET = BalanceSheet.parse(json.BALANCE_SHEET);

            return qr;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<QuickReport> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(QuickReport.parse(j));

        return arr;
    }

    static createQuickReport(): QuickReport {
        let qr = new QuickReport();
        
        qr.ZIP = new Zip();

        qr.FRANCHISE = new Franchise();

        qr.RISK = new Risk();

        qr.BALANCE_SHEET = new BalanceSheet();

        return qr;
    }

}
